import { render } from "./TextDataConfigViewer.vue?vue&type=template&id=02f37aa2&ts=true"
import script from "./TextDataConfigViewer.vue?vue&type=script&lang=ts"
export * from "./TextDataConfigViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__